import React, { useEffect, useState } from "react";
import "./Style.css";
import { Link } from "react-router-dom";
import { listContacts } from "../../../services/pix.service";

import { MdKeyboardArrowRight } from "react-icons/md";
import { TbSettingsFilled } from "react-icons/tb";
import { css } from "@emotion/react";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";

import PixKeyCard from "./pix-key-card/PixKeyCard";
import QrcodeModal from "./qrcode-modal/QrcodeModal";
import CopiaeColaModal from "./copiaecola-modal/CopiaeColaModal";
import { KeysModal } from "../../../pages/Pagina-pix/keys-modal";
import { usePixKey } from "../../../hooks/usePixKey";
import { useAuth } from "../../../hooks/useAuth";
import { companyUserPermissions } from "../../../enums/companyUserPermissions";
import { userHasPermission } from "../../../utils/verifyUserPermission";

export default function () {
  const [mostrarCopiaeColaModal, setMostrarCopiaeColaModal] = useState(false);
  const [mostrarQrcodeModal, setMostrarQrcodeModal] = useState(false);
  const [contacts, setContacts] = useState();
  const [pixUsage, setPixUsage] = useState();
  const { user } = useAuth();

  const [keysModalIsOpen, setKeysModalIsOpen] = useState(false);
  const { pixKeys, pixKeysLoader, fetchPixKeys } = usePixKey();

  const getContacts = async () => {
    const contacts = await listContacts();
    setContacts(contacts.data);
  };

  const override = css`
    display: flex;
    margin: 0 auto;
    border-color: red;
  `;

  useEffect(() => {
    if (user?.accountTransactionUsages?.PIX) {
      const { used, free, remaining, tax } = user.accountTransactionUsages.PIX;
      setPixUsage({ used, free, remaining, tax });
    }
    getContacts();
    if(user && userHasPermission(user, companyUserPermissions.VIEW_PIX_KEY)) {
      fetchPixKeys();
    }
  }, [user]);

  return (
    <>
      <div className="pagina-pix">
        <div className="col-md-10 pagina-pix-container">
          <div className="header">
            <div className="col-xl-12">
              <label>
                <Link to={"/pagina-principal"}>
                  Pagina inicial
                  <MdKeyboardArrowRight size={20} />
                </Link>
                Pix
              </label>
              <p>Pix</p>
            </div>
          </div>

          <div className="body">
            <div className="d-flex col-md-12">
              <div className="col-md-6 d-flex gap-4">
                <h1>Enviar ou Receber</h1>
                <MdKeyboardArrowRight size={24} />
              </div>
              <div className="d-flex col-md-6">
                <Link to={!userHasPermission(user, companyUserPermissions.SEND_PIX) ? "" : "/pagina-pagar-pix"} title={!userHasPermission(user, companyUserPermissions.SEND_PIX) ? "Você não tem permissão para acessar essa funcionalidade" : ""}>
                  <div className={`svg-circle ${!userHasPermission(user, companyUserPermissions.SEND_PIX) && "disabled-button"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.63181 2.44714C7.93715 2.72703 7.95777 3.20146 7.67788 3.5068L4.70494 6.75H15C15.4142 6.75 15.75 7.08579 15.75 7.5C15.75 7.91422 15.4142 8.25 15 8.25H3.00002C2.70259 8.25 2.43327 8.07425 2.3135 7.802C2.19374 7.52975 2.24617 7.21246 2.44715 6.99321L6.57215 2.49321C6.85204 2.18787 7.32647 2.16724 7.63181 2.44714ZM2.25002 10.5C2.25002 10.0858 2.5858 9.75 3.00002 9.75H15C15.2974 9.75 15.5668 9.92576 15.6865 10.198C15.8063 10.4703 15.7539 10.7875 15.5529 11.0068L11.4279 15.5068C11.148 15.8121 10.6736 15.8328 10.3682 15.5529C10.0629 15.273 10.0423 14.7986 10.3221 14.4932L13.2951 11.25H3.00002C2.5858 11.25 2.25002 10.9142 2.25002 10.5Z"
                        fill="var(--text-primary)"
                      />
                    </svg>
                  </div>
                  <p>TRANSFERIR</p>
                </Link>
                <button 
                  onClick={() => !userHasPermission(user, companyUserPermissions.PAY_PIX_COPY_PASTE) ? null : setMostrarCopiaeColaModal(true)} 
                  title={!userHasPermission(user, companyUserPermissions.PAY_PIX_COPY_PASTE) ? "Você não tem permissão para acessar essa funcionalidade" : ""}
                >
                  <div className={`svg-circle ${!userHasPermission(user, companyUserPermissions.PAY_PIX_COPY_PASTE) && "disabled-button"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5H23.3333C24.6594 5 25.9312 5.52678 26.8689 6.46447C27.8065 7.40215 28.3333 8.67392 28.3333 10V11.6667H30C31.3261 11.6667 32.5979 12.1935 33.5355 13.1311C34.4732 14.0688 35 15.3406 35 16.6667V30C35 31.3261 34.4732 32.5979 33.5355 33.5355C32.5979 34.4732 31.3261 35 30 35H16.6667C15.3406 35 14.0688 34.4732 13.1311 33.5355C12.1935 32.5979 11.6667 31.3261 11.6667 30V28.3333H10C8.67392 28.3333 7.40215 27.8065 6.46447 26.8689C5.52678 25.9312 5 24.6594 5 23.3333V10C5 8.67392 5.52678 7.40215 6.46447 6.46447ZM15 30C15 30.442 15.1756 30.8659 15.4882 31.1785C15.8007 31.4911 16.2246 31.6667 16.6667 31.6667H30C30.442 31.6667 30.8659 31.4911 31.1785 31.1785C31.4911 30.8659 31.6667 30.442 31.6667 30V16.6667C31.6667 16.2246 31.4911 15.8007 31.1785 15.4882C30.8659 15.1756 30.442 15 30 15H16.6667C16.2246 15 15.8007 15.1756 15.4882 15.4882C15.1756 15.8007 15 16.2246 15 16.6667V30ZM25 11.6667H16.6667C15.3406 11.6667 14.0688 12.1935 13.1311 13.1311C12.1935 14.0688 11.6667 15.3406 11.6667 16.6667V25H10C9.55797 25 9.13405 24.8244 8.82149 24.5118C8.50893 24.1993 8.33333 23.7754 8.33333 23.3333V10C8.33333 9.55797 8.50893 9.13405 8.82149 8.82149C9.13405 8.50893 9.55797 8.33333 10 8.33333H23.3333C23.7754 8.33333 24.1993 8.50893 24.5118 8.82149C24.8244 9.13405 25 9.55797 25 10V11.6667Z"
                        fill="var(--text-primary)"
                      />
                    </svg>
                  </div>
                  <p>PIX COPIA E COLA</p>
                </button>
                <button
                  onClick={() => { !userHasPermission(user, companyUserPermissions.CREATE_PIX_CHARGE) ? null : setMostrarQrcodeModal(true); }}
                  title={!userHasPermission(user, companyUserPermissions.CREATE_PIX_CHARGE) ? "Você não tem permissão para acessar essa funcionalidade" : ""}
                >
                  <div className={`svg-circle ${!userHasPermission(user, companyUserPermissions.CREATE_PIX_CHARGE) && "disabled-button"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.79778 8.13112C5.73546 7.19344 7.00723 6.66666 8.33331 6.66666H25C26.3261 6.66666 27.5978 7.19344 28.5355 8.13112C29.4732 9.0688 30 10.3406 30 11.6667V13.3333H31.6666C32.9927 13.3333 34.2645 13.8601 35.2022 14.7978C36.1399 15.7355 36.6666 17.0072 36.6666 18.3333V28.3333C36.6666 29.6594 36.1399 30.9312 35.2022 31.8689C34.2645 32.8065 32.9927 33.3333 31.6666 33.3333H15C13.6739 33.3333 12.4021 32.8065 11.4644 31.8689C10.5268 30.9312 9.99998 29.6594 9.99998 28.3333V26.6667H8.33331C7.00723 26.6667 5.73546 26.1399 4.79778 25.2022C3.8601 24.2645 3.33331 22.9927 3.33331 21.6667V11.6667C3.33331 10.3406 3.8601 9.0688 4.79778 8.13112ZM13.3333 28.3333C13.3333 28.7754 13.5089 29.1993 13.8215 29.5118C14.134 29.8244 14.558 30 15 30H31.6666C32.1087 30 32.5326 29.8244 32.8452 29.5118C33.1577 29.1993 33.3333 28.7753 33.3333 28.3333V18.3333C33.3333 17.8913 33.1577 17.4674 32.8452 17.1548C32.5326 16.8423 32.1087 16.6667 31.6666 16.6667H15C14.558 16.6667 14.134 16.8423 13.8215 17.1548C13.5089 17.4674 13.3333 17.8913 13.3333 18.3333V28.3333ZM26.6666 13.3333H15C13.6739 13.3333 12.4021 13.8601 11.4644 14.7978C10.5268 15.7355 9.99998 17.0072 9.99998 18.3333V23.3333H8.33331C7.89129 23.3333 7.46736 23.1577 7.1548 22.8452C6.84224 22.5326 6.66665 22.1087 6.66665 21.6667V11.6667C6.66665 11.2246 6.84224 10.8007 7.1548 10.4881C7.46736 10.1756 7.89128 9.99999 8.33331 9.99999H25C25.442 9.99999 25.8659 10.1756 26.1785 10.4881C26.4911 10.8007 26.6666 11.2246 26.6666 11.6667V13.3333ZM19.7978 19.7978C20.7355 18.8601 22.0072 18.3333 23.3333 18.3333C24.6594 18.3333 25.9312 18.8601 26.8688 19.7978C27.8065 20.7355 28.3333 22.0072 28.3333 23.3333C28.3333 24.6594 27.8065 25.9312 26.8688 26.8689C25.9312 27.8065 24.6594 28.3333 23.3333 28.3333C22.0072 28.3333 20.7355 27.8065 19.7978 26.8689C18.8601 25.9312 18.3333 24.6594 18.3333 23.3333C18.3333 22.0072 18.8601 20.7355 19.7978 19.7978ZM23.3333 21.6667C22.8913 21.6667 22.4674 21.8423 22.1548 22.1548C21.8422 22.4674 21.6666 22.8913 21.6666 23.3333C21.6666 23.7753 21.8422 24.1993 22.1548 24.5118C22.4674 24.8244 22.8913 25 23.3333 25C23.7753 25 24.1993 24.8244 24.5118 24.5118C24.8244 24.1993 25 23.7753 25 23.3333C25 22.8913 24.8244 22.4674 24.5118 22.1548C24.1993 21.8423 23.7753 21.6667 23.3333 21.6667Z"
                        fill="var(--text-primary)"
                      />
                    </svg>
                  </div>
                  <p>COBRAR COM PIX</p>
                </button>
                <Link to={!userHasPermission(user, companyUserPermissions.VIEW_PIX_LIMITS) ? null : "/limites-pix"}>
                <button
                  title={!userHasPermission(user, companyUserPermissions.VIEW_PIX_LIMITS) ? "Você não tem permissão para acessar essa funcionalidade" : ""}
                >
                  <div className={`svg-circle ${!userHasPermission(user, companyUserPermissions.VIEW_PIX_LIMITS) && "disabled-button"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.7978 6.46447C20.7355 5.52678 22.0072 5 23.3333 5C24.6594 5 25.9312 5.52678 26.8689 6.46447C27.4012 6.99681 27.8011 7.63683 28.0474 8.33333H33.3333C34.2538 8.33333 35 9.07953 35 10C35 10.9205 34.2538 11.6667 33.3333 11.6667H28.0474C27.8011 12.3632 27.4012 13.0032 26.8689 13.5355C25.9312 14.4732 24.6594 15 23.3333 15C22.0072 15 20.7355 14.4732 19.7978 13.5355C19.2655 13.0032 18.8656 12.3632 18.6193 11.6667H6.66667C5.74619 11.6667 5 10.9205 5 10C5 9.07953 5.74619 8.33333 6.66667 8.33333H18.6193C18.8656 7.63683 19.2655 6.99681 19.7978 6.46447ZM23.3333 8.33333C22.8913 8.33333 22.4674 8.50893 22.1548 8.82149C21.8423 9.13405 21.6667 9.55797 21.6667 10C21.6667 10.442 21.8423 10.866 22.1548 11.1785C22.4674 11.4911 22.8913 11.6667 23.3333 11.6667C23.7754 11.6667 24.1993 11.4911 24.5118 11.1785C24.8244 10.866 25 10.442 25 10C25 9.55797 24.8244 9.13405 24.5118 8.82149C24.1993 8.50893 23.7754 8.33333 23.3333 8.33333ZM9.7978 16.4645C10.7355 15.5268 12.0072 15 13.3333 15C14.6594 15 15.9312 15.5268 16.8689 16.4645C17.4012 16.9968 17.8011 17.6368 18.0474 18.3333H33.3333C34.2538 18.3333 35 19.0795 35 20C35 20.9205 34.2538 21.6667 33.3333 21.6667H18.0474C17.8011 22.3632 17.4012 23.0032 16.8689 23.5355C15.9312 24.4732 14.6594 25 13.3333 25C12.0072 25 10.7355 24.4732 9.7978 23.5355C9.26546 23.0032 8.86555 22.3632 8.61929 21.6667H6.66667C5.74619 21.6667 5 20.9205 5 20C5 19.0795 5.74619 18.3333 6.66667 18.3333H8.61929C8.86555 17.6368 9.26546 16.9968 9.7978 16.4645ZM13.3333 18.3333C12.8913 18.3333 12.4674 18.5089 12.1548 18.8215C11.8423 19.134 11.6667 19.558 11.6667 20C11.6667 20.442 11.8423 20.866 12.1548 21.1785C12.4674 21.4911 12.8913 21.6667 13.3333 21.6667C13.7754 21.6667 14.1993 21.4911 14.5118 21.1785C14.8244 20.8659 15 20.442 15 20C15 19.558 14.8244 19.1341 14.5118 18.8215C14.1993 18.5089 13.7754 18.3333 13.3333 18.3333ZM24.7978 26.4645C25.7355 25.5268 27.0072 25 28.3333 25C29.6594 25 30.9312 25.5268 31.8689 26.4645C32.4012 26.9968 32.8011 27.6368 33.0474 28.3333H33.3333C34.2538 28.3333 35 29.0795 35 30C35 30.9205 34.2538 31.6667 33.3333 31.6667H33.0474C32.8011 32.3632 32.4012 33.0032 31.8689 33.5355C30.9312 34.4732 29.6594 35 28.3333 35C27.0072 35 25.7355 34.4732 24.7978 33.5355C24.2655 33.0032 23.8656 32.3632 23.6193 31.6667H6.66667C5.74619 31.6667 5 30.9205 5 30C5 29.0795 5.74619 28.3333 6.66667 28.3333H23.6193C23.8656 27.6368 24.2655 26.9968 24.7978 26.4645ZM28.3333 28.3333C27.8913 28.3333 27.4674 28.5089 27.1548 28.8215C26.8423 29.1341 26.6667 29.558 26.6667 30C26.6667 30.442 26.8423 30.8659 27.1548 31.1785C27.4674 31.4911 27.8913 31.6667 28.3333 31.6667C28.7754 31.6667 29.1993 31.4911 29.5118 31.1785C29.8244 30.8659 30 30.442 30 30C30 29.558 29.8244 29.1341 29.5118 28.8215C29.1993 28.5089 28.7754 28.3333 28.3333 28.3333Z"
                        fill="var(--text-primary)"
                      />
                    </svg>
                  </div>
                  <p>MEUS LIMITES PIX</p>
                </button>
                </Link>
              </div>
            </div>
            {
              userHasPermission(user, companyUserPermissions.SEND_PIX) && 
                <div className="col-md-12">
                  <h2>Contatos Recentes</h2>
                  <div className="d-flex">
                    {contacts &&
                      contacts.map((item, index) => {
                        return (
                          <div className="recent-card" key={index}>
                            <Link
                              state={{ pixKey: item.key }}
                              to={{ pathname: "/pagina-pagar-pix" }}
                              key={item.id}
                            >
                              <div className="recent-icons">
                                {item.name.split(" ").length > 1
                                  ? item.name.split(" ")[0].split("")[0] +
                                    item.name.split(" ")[1].split("")[0]
                                  : item.name.split(" ")[0].split("")[0]}
                              </div>
                              <div className="recent-content">
                                <p>{item.name}</p>
                                <span>{item.bank}</span>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                  </div>
                </div>
            }
          </div>

          <hr />

          {userHasPermission(user, companyUserPermissions.VIEW_PIX_KEY) && !pixKeysLoader &&
            <div className="footer">
              <div className="col-md-10 d-flex">
                <div className="d-flex col-md-4">
                  <h1>Minhas Chaves PIX</h1>
                  <MdKeyboardArrowRight size={24} />
                </div>
                <div>
                  <button onClick={() => setKeysModalIsOpen(true)}>
                    <TbSettingsFilled size={16} />
                    Gerenciar chaves
                  </button>
                </div>
              </div>
              <div className="d-flex col-md-10 keys-area">
                {!pixKeysLoader ? (<>{(pixKeys && pixKeys.length > 0) ? (
                  <>
                    {pixKeys.map((item) => (
                      <PixKeyCard
                        key={item.id}
                        chave={item.key}
                        tipo={item.type}
                        id={item.id}
                        />
                      ))}
                  </>
                ) : (
                  ("Sem chaves no momento")
                )}</>) : (<BeatLoader
                  color={"var(--secondary-color)"}
                  loading={pixKeysLoader}
                  css={override}
                  size={20}
                  />)}
              </div>
            </div>
          }
        </div>
      </div>
      <QrcodeModal
        setMostrarQrcodeModal={setMostrarQrcodeModal}
        mostrarQrcodeModal={mostrarQrcodeModal}
        rows={pixKeys}
        setKeysModalIsOpen={setKeysModalIsOpen}
      />
      <CopiaeColaModal
        setMostrarCopiaeColaModal={setMostrarCopiaeColaModal}
        mostrarCopiaeColaModal={mostrarCopiaeColaModal}
        pixUsage={pixUsage}
      />

      <KeysModal
        isOpen={keysModalIsOpen}
        setKeysModalIsOpen={setKeysModalIsOpen}
      />
    </>
  );
}